import { useEffect, useMemo } from 'react'
import {
  formatDateToPtBr,
  initialQueryState,
  OptionsHelper,
  useDebounce,
} from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import {
  ActiveFilter,
  ActiveFiltersBar,
  CustomSelect,
  DateInput,
  Input,
  IOption,
  TableFilter,
  TableFilters,
} from '../../../../../../components'

export const HistoricoListSearchComponent = () => {
  const { updateState } = useQueryRequest()
  const { response, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const total = response?.totalElements ?? 0

  const debouncedFilters = useDebounce(filters, 500)

  const search = useMemo(
    () =>
      [
        debouncedFilters.estado ? `estado:${debouncedFilters.estado.value}` : '',
        debouncedFilters.protocolo.trim() ? `protocolo~*${debouncedFilters.protocolo.trim()}*` : '',
        debouncedFilters.solicitacao ? `dataSolicitacao>${debouncedFilters.solicitacao}` : '',
      ]
        .filter(Boolean)
        .join(','),
    [debouncedFilters]
  )

  useEffect(() => {
    updateState({ ...initialQueryState, search })
  }, [search, updateState])

  // Chips da faixa "Filtros ativos": cada × limpa só o seu campo. Data pura via split
  // (formatDateToPtBr), sem `new Date`, para não voltar um dia no fuso do Brasil.
  const activeFilters: ActiveFilter[] = [
    filters.estado && {
      key: 'estado',
      label: 'Estado',
      value: filters.estado.label,
      onRemove: () => setFilter('estado', undefined),
    },
    filters.protocolo.trim() && {
      key: 'protocolo',
      label: 'Protocolo',
      value: `“${filters.protocolo.trim()}”`,
      onRemove: () => setFilter('protocolo', ''),
    },
    filters.solicitacao && {
      key: 'solicitacao',
      label: 'A partir de',
      value: formatDateToPtBr(filters.solicitacao),
      onRemove: () => setFilter('solicitacao', ''),
    },
  ].filter((filter): filter is ActiveFilter => Boolean(filter))

  return (
    <TableFilters
      footer={
        <ActiveFiltersBar
          filters={activeFilters}
          onClearAll={clearFilters}
          summary={
            isLoading
              ? 'Buscando…'
              : `${total} ${total === 1 ? 'atendimento encontrado' : 'atendimentos encontrados'}`
          }
        />
      }
    >
      <TableFilter label='Protocolo' wide>
        <Input
          placeholder='Digite o protocolo'
          value={filters.protocolo}
          onChange={(e) => setFilter('protocolo', e.target.value)}
        />
      </TableFilter>
      <TableFilter label='Estado'>
        <CustomSelect
          placeholder='Selecione um estado'
          onChange={(estado?: IOption<number>) => setFilter('estado', estado ?? undefined)}
          fetchOptions={OptionsHelper.getOptionsEstadosAtendimento}
          value={filters.estado}
        />
      </TableFilter>
      <TableFilter label='A partir de'>
        <DateInput
          value={filters.solicitacao}
          onChange={(e) => setFilter('solicitacao', e.target.value)}
        />
      </TableFilter>
    </TableFilters>
  )
}
